import AnalyticsService from '@/services/AnalyticsService'

// **************************************************
//
// LOADING
//
// **************************************************
export const setLoadProgress = (state, progress) => {
  state.loading.progress = Math.min(progress, 1)
}
export const setLoadStep = (state, step) => {
  state.loading.step = step
  console.log('setLoadStep', step)
}
export const setLoadComplete = (state) => {
  state.loading.progress = 1
  state.loading.completed = true
}

// **************************************************
//
// ROUTE
//
// **************************************************
export const setRoute = (state, params) => {
  state.route.prev.parent = state.route.curr.parent
  state.route.prev.child = state.route.curr.child

  state.route.curr.parent = params.parent
  state.route.curr.child = params.child
}

export const setRouteAfterLoad = (state, value) => {
  console.log('setafterload', value)
  state.route.afterLoad = value
}

// **************************************************
//
// BLEND
//
// **************************************************
export const setBlendPercentage = (state, percent) => {
  state.blend.percent = percent
}

export const login = (state, value) => { 
  state.firebase.user_data = value
  state.firebase.logged_in = true 
  AnalyticsService.sendEvent('APP', 'change',  'firebase_auth', true); 
}

export const logout = (state, value) => { 
  state.firebase.user_data = null
  state.firebase.logged_in = false
  AnalyticsService.sendEvent('APP',  'change', 'firebase_auth', false);
}

export const setY = (state, value) => { 
  state.y = value 
}

export const setConstented = (state, value) => { 
  state.consented = value  
  AnalyticsService.sendEvent('APP',  'change', 'web_rtc_consent', value);
}
